// src/lib/businessType.js
//
// Derived from what a business has actually bought — not a separate field
// to keep in sync, so it can never drift from reality. Every business is
// Zilo-track by default (free tier included — that's Zilo's entry point,
// not a "nothing yet" state); the only way to be pure "tech_partner"
// (website-only, no Zilo at all) is the explicit packages.websiteOnly
// flag, set by the Stripe webhook only when a bundle with no Zilo grant
// is purchased and the business genuinely never had Zilo before.
//
// This used to infer "website-only" from plan/ziloPulse/ziloOmni, which
// broke the moment a business had webDevelopment AND was on the free
// tier (true for every business by default) — an admin manually granting
// a website package to an existing free-tier Zilo client would silently
// reclassify them as website-only and their whole Zilo dashboard would
// disappear, even though nothing about their actual Zilo access had
// changed. The explicit flag means granting webDevelopment can never by
// itself take Zilo away from anyone.
export function getBusinessType(biz) {
  const hasWebDev = !!biz?.packages?.webDevelopment;
  if (hasWebDev && biz?.packages?.websiteOnly) return "tech_partner";
  const hasZiloPaid = (biz?.plan && biz.plan !== "free") || !!biz?.packages?.ziloPulse || !!biz?.packages?.ziloOmni;
  if (hasWebDev && hasZiloPaid) return "both";
  if (hasWebDev) return "both"; // free-tier Zilo + a website package is still both, not website-only
  return "zilo"; // includes free-tier direct signups, not just paid plans
}

// Where someone should land right after login. Now a single shared
// Overview page for everyone (shows whichever service cards apply) rather
// than branching by type — Zilo-specific detail lives one level deeper,
// under its own submenu in the sidebar.
export function defaultLandingRoute() {
  return "/overview";
}
